"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.dimensionFingerprint = void 0;
var tslib_1 = require("tslib");
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
/**
 * Calculates dimension fingerprint; ensures that the optional vs default values are correctly reflected in
 * the fingerprint.
 *
 * @internal
 */
function dimensionFingerprint(dim) {
    var dimDefaults = {
        totals: [],
    };
    var withDefaultTotals = merge_1.default(dimDefaults, dim);
    return json_stable_stringify_1.default(withDefaultTotals);
}
exports.dimensionFingerprint = dimensionFingerprint;
//# sourceMappingURL=fingerprint.js.map